import React, { useState } from 'react';
import { Sidebar } from './sidebar';
import { Content } from './content';
import { GroupDetail } from '../../shared/details/groups';
import clx from 'classnames';
import { useGeneral } from '../../../stores/useGeneral';

export const Messenger = ({externalClass}) => {
      const {darkmode} = useGeneral(state=>state)
      return (
      <div>
        <div 
        id="chat" 
        className={clx(
          externalClass,
          darkmode,
          'lg:grid grid-cols-12 scrollbar dark h-screen w-full overflow-hidden dark:bg-black',
        )} >
           <Sidebar />
           <Content externalClass={externalClass} />
           <GroupDetail />
        </div>
      </div>
    )
} 

export default Messenger;
